import { useEffect, useMemo, useState } from 'react';
import MeritoButton from '../../../components/common/MeritoButtons/MeritoButtons';
import styles from './AccountsUpdate.module.scss';
import { HiChevronRight as RightArrowIcon } from 'react-icons/hi';
import { RestS } from '../../../rest/rest-service';
import CircularLoader from '../../../components/common/CircularLoader/CircularLoader';
import { useAppDispatch, useAppSelector } from '../../../redux/reduxHooks';
import { getLocalUser } from '../../../components/functions/utilities';
import Integrations from '../../../components/common/Integrations/Integration';
import { VscDebugDisconnect as ConnectIcon } from "react-icons/vsc";
import { useSearchParams } from 'react-router-dom';
import useModal from '../../../components/Hooks/useModal';
import { setRefreshAccountUpdate } from '../../../redux/financeStatement/financeStatement';
import { IpNames, ProductFetchingProgress } from '../../../interfaces/interfaces';
import { LoadingIndicator } from 'react-select/dist/declarations/src/components/indicators';
import { IpRestS } from '../../../rest/ipRest-service';


type Props = {
    ipConfigs: { [x: string]: { connectionStatus: boolean, logo: string } },
    handleNextStep: () => void;
    connectionToggle: () => void;
    updateObj: { integrationPartnerDetail: { companyName: string, _id: string }, updateAvailable: boolean, isConnected: boolean },
    productFetchingLoading: boolean;
    onShopifyUpdateComplete: (status: ProductFetchingProgress, isProductUpdate: boolean) => void;
    productFetchingStatus: { status: ProductFetchingProgress, isProductUpdate: boolean },
    setProductFetchingStatus: ({ status, isProductUpdate, isJobPresent }: { status: ProductFetchingProgress, isProductUpdate: boolean, isJobPresent: boolean }) => void
};

const IP_NAME = "Shopify";



const AccountUpdate = ({ ipConfigs, handleNextStep, updateObj, connectionToggle, productFetchingLoading, onShopifyUpdateComplete, productFetchingStatus, setProductFetchingStatus }: Props) => {
    const [loading, setLoading] = useState(true);
    const [productDfInProgress, setProductDfInProgress] = useState(false);
    const { dfProgress } = useAppSelector((state) => state.dataFetchingProgress);
    const { refreshAccountUpdate } = useAppSelector((state) => state.financeStatement);
    // const [isFetchingCompleted, setIsFetchingCompleted] = useState(false);
    const dispatch = useAppDispatch();
    // console.log('updateObj', updateObj)

    const getStatusByIp = async () => {
        try {
            const data = await RestS.fetchProductCostUpdateStatus();
            // const dfStatus = await RestS.getDfStatusByIp('Shopify');
            if (data?.isJobPresent) {
                if (data?.isInProgress) {
                    setProductDfInProgress(data?.isInProgress);
                    onShopifyUpdateComplete(data?.status, data?.isProductUpdate);
                    setProductFetchingStatus({ status: data?.status, isProductUpdate: data?.isProductUpdate, isJobPresent: data?.isJobPresent })
                } else {
                    setProductFetchingStatus({ status: data?.status, isProductUpdate: data?.isProductUpdate, isJobPresent: data?.isJobPresent })
                    onShopifyUpdateComplete(data?.status, data?.isProductUpdate)
                }
            }
            return data;
        } catch (error) {
            console.log(error);
        }
    }


    useEffect(() => {
        (async () => {
            setLoading(true);
            try {
                const data = await getStatusByIp();
            } catch (error) {
                console.log('coming here')
                console.log('error', error)
                console.log(error);
            } finally {
                setLoading(false)
            }
        })()
    }, []);


    const updateShopify = () => {
        const user = getLocalUser()
        Integrations(
            updateObj?.integrationPartnerDetail?.companyName,
            updateObj?.integrationPartnerDetail?._id,
            user,
            '',
            1,
            () => { },
            () => { },
            true,
        );
    }

    const connectShopify = async () => {
        const user = getLocalUser();
        const { data: ipData } = await IpRestS.getFilteredIpByNames([IpNames.shopify]).catch((error) => {
            return {
                data: []
            }
        });
        if (ipData.length) {
            const filteredIp = ipData[0];
            console.log('filteredIp', filteredIp)
            Integrations(
                filteredIp.companyName,
                filteredIp?._id,
                user,
                '',
                1,
                () => { },
                () => { },
                false,
            );
        }
    }



    useEffect(() => {
        if (refreshAccountUpdate) {
            getStatusByIp();
            dispatch(setRefreshAccountUpdate(false));
        }
    }, [refreshAccountUpdate]);

    const connectionStatus = useMemo(() => {
        return ipConfigs["Shopify"] ? ipConfigs["Shopify"]['connectionStatus'] : false;
    }, [ipConfigs]);

    // console.log('connection status', connectionStatus, "ipConfig", ipConfigs)

    // console.log('connectionstatus', connectionStatus, 'productFetchingLoading', productFetchingLoading)


    const showColdStateText = useMemo(() => {
        if (productFetchingStatus.status == ProductFetchingProgress.success && productFetchingStatus.isProductUpdate) {
            return {
                title: <>Shopify Update Complete!</>,
                subTitle: <>You can continue creating your P&L Report.</>,
                button: <MeritoButton isIconToRight={true} icon={<RightArrowIcon />} btnText='Next' type='primary-1' onClick={() => handleNextStep()} />
            }
        } else if (productFetchingStatus.status == ProductFetchingProgress.success && !productFetchingStatus.isProductUpdate) {
            return {
                title: <>Shopify Data Fetching Complete!</>,
                subTitle: <>You can continue creating your P&L Report.</>,
                button: <MeritoButton isIconToRight={true} icon={<RightArrowIcon />} btnText='Next' type='primary-1' onClick={() => handleNextStep()} />
            }
        } else if (productFetchingStatus.status == ProductFetchingProgress.failed && productFetchingStatus.isProductUpdate) {
            return {
                title: <>Shopify App Update Failed!</>,
                subTitle: <>Contact us on <span className={styles.underlineText}>+91 9867054499</span></>,
                button: <></>
            }
        } else if (productFetchingStatus.status == ProductFetchingProgress.failed && !productFetchingStatus.isProductUpdate) {
            return {
                title: <>Shopify Data Fetching Failed!</>,
                subTitle: <>Contact us on <span className={styles.underlineText}>+91 9867054499</span></>,
                button: <></>
            }
        } else {
            return null;
        }
    }, [productFetchingStatus])

    return (
        <div className={styles.accountUpdateRoot}>
            {loading ?
                <div className={styles.loadingContainer}>
                    <CircularLoader />
                </div>
                : <div className={styles.accountUpdate}>
                    <div className={styles.dataSourceImg}>
                        {ipConfigs[IP_NAME] != undefined ? <img src={ipConfigs[IP_NAME].logo} alt="" /> : null}
                    </div>
                    <div className={styles.textContainer}>
                        <div className={styles.title}>
                            {!connectionStatus && !productFetchingLoading ?
                                "Connect Your Shopify Account"
                                : showColdStateText ?
                                    showColdStateText?.title :
                                    productDfInProgress || productFetchingLoading ?
                                        !productFetchingStatus?.isProductUpdate ?
                                            'Fetching Shopify Data!'
                                            :
                                            `Updating Your App`
                                        : 'Update the Merito Shopify App!'}
                        </div>
                        <div className={styles.subTitle}>
                            {!connectionStatus && !productFetchingLoading ?
                                "Connect your Shopify account to sync its data to Merito."
                                : showColdStateText ? showColdStateText?.subTitle :
                                    productDfInProgress || productFetchingLoading ?
                                        !productFetchingStatus?.isProductUpdate ?
                                            <>
                                                This may take a few minutes.
                                                <br /> <br />
                                                While you wait, click Next to continue the other steps.
                                            </>
                                            :
                                            <>
                                                This may take a few minutes.
                                                <br /> <br />
                                                While you wait, click Next to continue the other steps.
                                            </>
                                        :
                                        <>
                                            This enables us to auto-fill the cost price for your products.
                                            <br /> <br />
                                            This may take a few minutes.
                                        </>}
                        </div>
                    </div>

                    <div className={styles.actionBtnContainer}>
                        {!connectionStatus && !productFetchingLoading ?
                            <>
                                <MeritoButton btnText='Connect' icon={<ConnectIcon color='#fff' />} type='primary-1' onClick={connectShopify} />
                                {/* <MeritoButton btnText='Skip' type='secondary-2' onClick={() => handleNextStep()} /> */}
                            </>
                            : showColdStateText ?
                                showColdStateText?.button
                                : productDfInProgress || productFetchingLoading ?
                                    <>
                                        <MeritoButton btnText={!productFetchingStatus?.isProductUpdate ? 'Fetching Data' : 'Updating'} loading={true} disabled={true} showLoadingWithText={true} isIconToRight={true} type='secondary-1' onClick={() => { }} />
                                        <MeritoButton isIconToRight={true} icon={<RightArrowIcon />} btnText='Next' type='primary-1' onClick={() => handleNextStep()} />
                                    </>
                                    :
                                    <>
                                        <MeritoButton icon={<RightArrowIcon />} isIconToRight={true} onClick={updateShopify} btnText='Update' type='primary-1' />
                                        {/* <MeritoButton icon={<RightArrowIcon />} btnText='Next' type='primary-1' onClick={() => handleNextStep()} /> */}
                                    </>}
                    </div>

                </div>}



        </div>
    );
}

export default AccountUpdate;